import '../assets/css/styles.css';
import '../assets/js/main.js';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import Preloader from "../assets/js/preloader.js";
import { NavLink } from "react-router-dom";

import Button from 'react-bootstrap/Button';



const Faq = () => {
    return (
        <div>
            <section className="about">
                <section className="home" style={{ minHeight: "100vh" }}>
                    <section className="privacy">
                        <span className="privacy_policy">FAQ</span>
                    </section>
                    <section className="faq section-padding">
                        <div className="rowfaq justify-content-center">
                            <div className="col-lg-10">
                                <div id="accordion">
                                    <div className="accordion-item">
                                        <div className="accordion-header" data-toggle="collapse" data-target="#collapse-01">
                                            <h3>Co to jest drop?</h3>
                                        </div>
                                        <div className="collapse show" id="collapse-01">
                                            <div className="accordion-body">
                                                <p>Drop to ekskluzywne losowanie przedmiotu</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <div className="accordion-header collapsed" data-toggle="collapse" data-target="#collapse-02">
                                            <h3>Dlaczego produkt nie ma przy sobie daty premiery?</h3>
                                        </div>
                                        <div className="collapse" id="collapse-02">
                                            <div className="accordion-body">
                                                <p>Jest tak najprawdopodbniej dlatego, że oficjalna data nie została jeszcze ogłoszona</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <div className="accordion-header collapsed" data-toggle="collapse" data-target="#collapse-03">
                                            <h3>Przycisk "SKLEP" nie działa</h3>
                                        </div>
                                        <div className="collapse" id="collapse-03">
                                            <div className="accordion-body">
                                                <p>Możliwe jest, że próbujesz kliknąć nieaktywny odnośnik, działające linki mają kolor niebieski</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <div className="accordion-header collapsed" data-toggle="collapse" data-target="#collapse-04">
                                            <h3>Co oznaczają żółte płomienie przy kafelce premiery?</h3>
                                        </div>
                                        <div className="collapse" id="collapse-04">
                                            <div className="accordion-body">
                                                <p>Oznacza to, że odsprzedaż danego przedmiotu będzie przypuszczalnie duża</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </div>
    );
}

export default Faq;
